export default "__VITE_ASSET__BUZgRnC7__"